import { render, staticRenderFns } from "./countriesDetail.vue?vue&type=template&id=cb03fcda"
import script from "./countriesDetail.vue?vue&type=script&lang=js"
export * from "./countriesDetail.vue?vue&type=script&lang=js"
import style0 from "./countriesDetail.vue?vue&type=style&index=0&id=cb03fcda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports